import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';

import {
  NavBar,
  HeadingDisplay,
  ContentDisplay,
  Heading,
  Row,
  BaseIcon,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';

import { removeBodyScroll } from '@/modules/common/helpers/browser';

interface IData {
  requestTermsSignature: {
    productId: string;
    productName: string;
    documents: {
      label: string;
      url: string;
    }[];
  }[];
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm'): void;
}
interface Props {
  isOpen: boolean;
  data: IData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TermsSignature',
  props: {
    isOpen: { type: Boolean },
    data: null
  },
  emits: ["close", "confirm"],
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  data: IData;
}





const productName = computed(
  () => props.data.requestTermsSignature[0].productName
);

const documents = computed(() => props.data.requestTermsSignature[0].documents);

function openDocument(url: string) {
  window.open(url, '_blank');
}

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);

return { __sfc: true,props, productName, documents, openDocument, NavBar, HeadingDisplay, ContentDisplay, Heading, Row, BaseIcon, ButtonContainer, ButtonPrimary, SideSheet, BackButton }
}

})